// component
import IconProvider from '../../../components/IconProvider';

// ----------------------------------------------------------------------


const linkList = [
  {
    label:'OVERVIEW',
    title: 'Home',
    path: '/',
    icon: 'mingcute:sun-line',
  },
  {
    label:'',
    title: 'Agenda',
    path: '/tarefas',
    icon: 'mingcute:alarm-1-line',
  },
  {
    label:'',
    title: 'Hábitos',
    path: '/habitos',
    icon: 'mingcute:flower-4-fill',
  },
  {
    label:'',
    title: 'Diário',
    path: '/mood-tracker',
    icon: 'mingcute:moon-stars-line',
  },
  {
    label:'',
    title: 'Sala de Meditação',
    path: '/breath-room',
    icon: 'mingcute:lotus-line',
  }
];

export default linkList;